/* eslint-disable @typescript-eslint/no-unused-vars */
import { Step, EmailAction, TemplateEmailAction } from 'interface/experience/experience.interface';
import { EMAIL_STORE_ACTION_TYPE, EmailState, EmailStateItem } from './email.type';
import { createReducer, getEmailActionFromStep } from 'store/helper';
import { SetInstanceAction, SetTemplateAction } from 'store/templated-experience/templated-experience.type';
import { UpdateEmailAction } from 'store/actionTypes';
import { EmailStatePayload, EmailTemplatePayload } from 'interface/email/email.type';

const initialState: EmailState = {
  byRefId: {},
  allRefId: [],
};

export default createReducer(initialState, {
  SET_TEMPLATE: setTemplate,
  SET_INSTANCE: setInstance,
  CLEAR_JOURNEY: clearJourney,
  [EMAIL_STORE_ACTION_TYPE.UPDATE_EMAIL]: updateEmail,
});

function clearJourney() {
  return initialState;
}

function flattenEmailAction(email: TemplateEmailAction, isTemplate = false, stepIdx = 0): EmailStateItem {
  const template: EmailStatePayload['template'] = {};

  Object.entries(email.payload?.template ?? {}).forEach(([key, value]) => {
    template[key] = {
      providerTemplateData: isTemplate ? value.providerTemplateData : {},
      providerTemplateId: isTemplate ? value.providerTemplateId : '',
      journeyEmailTemplateData: value.providerTemplateData,
      journeyEmailTemplateId: value.providerTemplateId,
    };
  });

  return {
    ...email,
    id: email.payload?.id?.toUpperCase(),
    name: email.payload?.name,
    payloadType: email.payload?.payloadType,
    payload: email.payload && {
      ...email.payload,
      template,
    },
    isOptional: isTemplate ? email.isOptional : false,
    stepIdx,
  };
}

function setTemplate(state: EmailState, action: SetTemplateAction): EmailState {
  const preserveInstance = action.payload.preserveInstance;
  const byRefId: EmailState['byRefId'] = preserveInstance ? state.byRefId : {};
  const allRefId: EmailState['allRefId'] = preserveInstance ? state.allRefId : [];

  action.payload?.template?.steps?.forEach((step, idx) => {
    const email = getEmailActionFromStep(step);
    if (email) {
      if (preserveInstance) {
        if (byRefId[email.refId]) {
          const payload = state.byRefId[email.refId].payload;
          const template: EmailStatePayload['template'] = payload?.template ?? {};

          email.payload?.template &&
            Object.entries(email.payload.template).forEach(([key, value]) => {
              template[key] = {
                ...(template[key] ?? {}),
                providerTemplateData: value.providerTemplateData,
                providerTemplateId: value.providerTemplateId,
              };
            });
          byRefId[email.refId] = {
            ...state.byRefId[email.refId],
            payload: payload && {
              ...payload,
              template,
            },
            isOptional: email.isOptional,
          };
        } else {
          byRefId[email.refId] = flattenEmailAction(email, true, idx);
        }
      } else {
        byRefId[email.refId] = flattenEmailAction(email, true, idx);
      }
      if (!allRefId.includes(email.refId)) {
        allRefId.push(email.refId);
      }
    }
  });
  return { ...state, byRefId, allRefId };
}

function setInstance(state: EmailState, action: SetInstanceAction): EmailState {
  if (!action.payload.updateNewReducer) return state;

  const byRefId: EmailState['byRefId'] = {};
  const allRefId: EmailState['allRefId'] = [];

  action.payload?.instance?.steps.forEach((step: Step, idx: number) => {
    const email = getEmailActionFromStep(step);

    if (email) {
      byRefId[email.refId] = flattenEmailAction(email, false, idx);
      allRefId.push(email.refId);
    }
  });

  return {
    ...state,
    byRefId,
    allRefId,
  };
}

function updateEmail(state: EmailState, action: UpdateEmailAction): EmailState {
  return { ...state, byRefId: { ...state.byRefId, [action.payload.refId]: action.payload } };
}
